import { render } from "./ContentBlockForm.vue?vue&type=template&id=1a6f2194&ts=true"
import script from "./ContentBlockForm.vue?vue&type=script&lang=ts"
export * from "./ContentBlockForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Contents/Blocks/ContentBlockForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a6f2194"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a6f2194', __exports__)) {
    api.reload('1a6f2194', __exports__)
  }
  
  module.hot.accept("./ContentBlockForm.vue?vue&type=template&id=1a6f2194&ts=true", () => {
    api.rerender('1a6f2194', render)
  })

}


export default __exports__